import {createApp} from 'vue'
import App from './App.vue'
import Login from './Login.vue'
import LoginPT from './pt/Login.vue'
import AppPT from './pt/App.vue'
import AppMI from './mi/App.vue'
import axios from 'ts-axios-new'
import {createRouter, createWebHashHistory} from 'vue-router';
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {update} from './libs/utils'
import {routes} from './routes';
import {routes_pt} from './pt/routes';
import {routes_mi} from './mi/routes';
import {getLocalObj} from "./libs/storage";
import {is_manager, is_mi} from "./libs/permission";
import {changeProduct, getProduct, getProductList} from "./libs/app";


const router = createRouter({
    history: createWebHashHistory(),
    routes
});

const router_pt = createRouter({
    history: createWebHashHistory(),
    routes: routes_pt
});

const router_mi = createRouter({
    history: createWebHashHistory(),
    routes: routes_mi
});

let login: any = null;
declare var google: any;

export const root_props = {
    // user info
    user: {
        user_id: '',
        avatar: '',
        name: '',
        email: '',
        products: [],
    },
    country_list: [],
    user_list: [],
    authorization: '',
    part_time_mode: false,
    product: null,
    cdn_url: import.meta.env.VITE_CDN_URL
};

function disable_manager_board() {
    router.beforeEach((to, from, next) => {
        if (to.path === '/part-time') {
            next('/'); // 重定向到根路径
        } else {
            next();
        }
    });
}

function init() {
    if (!is_manager()) {
        disable_manager_board()
    }
    const app = create_app()
    app.use(ElementPlus, {locale: zhCn});
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    const vm = app.mount('#app');
    root_props.product = getProduct()
    update(vm, root_props);
}

function create_app() {
    if(is_mi()) {
        const app = createApp(AppMI);
        app.use(router_mi);
        return app
    } else {
        const app = createApp(App);
        app.use(router);
        return app

    }
}
function login_pt() {
    const app = createApp(LoginPT);
    app.use(ElementPlus, {locale: zhCn});
    app.mount('#login');
    document.getElementById('login').style.height = '100vh'
}

function init_pt() {
    disable_manager_board()
    const app = createApp(AppPT);
    app.use(router_pt);
    app.use(ElementPlus, {locale: zhCn});
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    const vm = app.mount('#app');
    update(vm, root_props);
}

window.onload = function () {
    const path = window.location.pathname;
    root_props.part_time_mode = path.startsWith('/part-time')
    // 同源请求统一携带 product header
    axios.interceptors.request.use(function (config) {
        const currentDomain = window.location.origin;
        if (config.url.startsWith(currentDomain) || !config.url.startsWith("http")) {
            config.headers['product'] = getProduct().key;
        }
        return config
    }, function (error) {
        return Promise.reject(error);
    })
    axios.get(`/cms/v1/me`, {}).then(res => {
        const user = res.data.data
        update(root_props.user, user)
        if (root_props.part_time_mode) {
            const allowed = user.products || []
            const saved = getProduct()
            const product = getProductList().find(item => item.key === saved.key && allowed.includes(item.key))
                || getProductList().find(item => allowed.includes(item.key))
                || getProductList()[0]
            changeProduct(product)
            init_pt()
        }else {
            init();
        }
    }, _ => {
        if (root_props.part_time_mode) {
            login_pt();
        }else {
            google.accounts.id.initialize({
                client_id: import.meta.env.VITE_OAUTH2_CLIENT_ID,
                callback: (response: any) => {
                    axios.post('/cms/v1/oauth2/login', {
                        platform: 'google',
                        id_token: response.credential
                    }).then(res => {
                        update(root_props.user, res.data.data);
                        if (login) {
                            login.unmount();
                        }
                        init();
                    });
                },
                auto_select: true,
            });
            google.accounts.id.prompt((notification: any) => {
                if (notification.isDisplayMoment() && notification.isNotDisplayed()) {
                    login = createApp(Login);
                    login.mount('#login');
                }
            });
        }

    })


    // if(path.startsWith('/part-time')) {
    //     console.log("enter part time mode.");
    //     root_props.part_time_mode = true
    //     const authorization = getLocalObj('authorization', null);
    //     if (authorization) {
    //         axios.get(`/cms/v1/me`, {headers: {authorization}}).then(res => {
    //             const user = res.data.data
    //             root_props.user.name = user['name']
    //             axios.interceptors.request.use(function (config) {
    //                 config.headers['Authorization'] = authorization;
    //                 return config
    //             }, function (error) {
    //                 return Promise.reject(error);
    //             })
    //             root_props.authorization = authorization;
    //             init_pt()
    //         }, _ => {
    //             login_pt();
    //         })
    //     } else {
    //         login_pt();
    //     }
    // } else {
    //     root_props.part_time_mode = false
    //     google.accounts.id.initialize({
    //         client_id: import.meta.env.VITE_OAUTH2_CLIENT_ID,
    //         callback: (response: any) => {
    //             axios.post('/cms/v1/oauth2/login', {
    //                 platform: 'google',
    //                 id_token: response.credential
    //             }).then(res => {
    //                 update(root_props.user, res.data.data);
    //                 if (login) {
    //                     login.unmount();
    //                 }
    //                 init();
    //             });
    //         },
    //         auto_select: true,
    //     });
    //     google.accounts.id.prompt((notification: any) => {
    //         if (notification.isDisplayMoment() && notification.isNotDisplayed()) {
    //             login = createApp(Login);
    //             login.mount('#login');
    //         }
    //     });
    // }
}
